import { Await, defer, useLoaderData } from "react-router-dom";
import api from "../storage/api";
import { Suspense } from "react";
import Loader from "../components/Modals/Loader";
import ServerMain from "./ServerMain";

const ServerPage = () => {
  const { events } = useLoaderData();
  
  return (
    <Suspense fallback={<Loader />}>
      <Await resolve={events}>
        {(loadedContent) => {
          return (
            <ServerMain content={loadedContent} />
          );
        }}
      </Await>
    </Suspense>
  );
};

export default ServerPage;

async function loadServerContent(params) {
  const server = params.server ? params.server : "";
  const response = await fetch(api.apiPath + "&path=home&server=" + server);

  if (!response.ok) {
    alert("Произошла ошибка при загрузке данных...");
  } else {
    return response.json();
  }
}

export function loader({params}) {
  return defer({
    events: loadServerContent(params),
  });
}
